import Insights from "../Insights";
import PopularCities from "../PopularCities";
import TrendingProperties from "../TrendingProperties";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";
import config from "@Config/index";

const CollectionRailsGroup = ({ isDesktop, fromBaidu, hideTrendingProperties = false }: any) => {
  const { propertyViewedFlag, searchViewedFlag } = useSelector(
    ({ appData }: AppState) => ({
      propertyViewedFlag: appData.propertyViewedFlag,
      searchViewedFlag: appData.searchViewedFlag,
    }),
    shallowEqual,
  );
  const isRepeatUser = propertyViewedFlag || searchViewedFlag;
  /**
   * The redesign moved the grey band off Popular Cities and onto Insights. That is part of
   * the same change as the personalised rails, so it rides the same flag — with it off the
   * page keeps the old arrangement: Popular Cities grey (its own `!isWhitelabel` default)
   * and Insights unbanded.
   */
  const showPersonalisedRails =
    useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.HOME_PERSONALISED_RAILS) || config.IS_CHINA_APP;

  return (
    <>
      {isRepeatUser && (
        <>
          <PopularCities isDesktop={isDesktop} greyBg={showPersonalisedRails ? false : undefined} />
          {!fromBaidu && <Insights isDesktop={isDesktop} greyBand={showPersonalisedRails} />}

          {/* Two personalised rails above already cover this — a third of the same shape adds nothing. */}
          {!hideTrendingProperties && (
            <TrendingProperties subSectionPaddingReduced isDesktop={isDesktop} />
          )}
        </>
      )}
      {!isRepeatUser && (
        <>
          <Insights isDesktop={isDesktop} fromBaidu={fromBaidu} greyBand={showPersonalisedRails} />
          <PopularCities
            isDesktop={isDesktop}
            fromBaidu={fromBaidu}
            greyBg={showPersonalisedRails ? false : undefined}
          />
          {!fromBaidu && <TrendingProperties isDesktop={isDesktop} />}
        </>
      )}
    </>
  );
};

export default wrapperHOC(CollectionRailsGroup, {
  componentName: "CollectionRailsGroup-Home",
  showForChina: true,
});
